import { Utils } from "@/plugins/utils"

export default {
    namespaced: true,
    state: {
        lstFm1: [],
        fm1: {},
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null,
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getFm1(state) {
            let fm1 = { ...state.fm1 }
            return fm1
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
    },
    mutations: {
        set(state, fm1) {
            state.fm1 = fm1 || {}
            if (fm1) state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.fm1 = {}
        },
        setParamsDataTable(state, payload) {
            state.lstFm1 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setFm1(state, fm1) {
            state.fm1 = fm1
        },
        setLstFm1(state, lstFm1) {
            state.lstFm1 = lstFm1
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },

        async find({ commit, dispatch }, fm1id) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios
                .get(`/OryxPlace/AnalysisFields/Find/${fm1id}`)
                .then(response => {
                    let fm1 = Utils.ValidateAxiosResponse(response.data)
                    commit("set", fm1)
                })
                .catch(error => {
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                })
            commit("setLoading", false)
        },

        async save({ getters, dispatch }, fm1) {
            if (getters.getUpdate) {
                return await dispatch("update", fm1)
            }
            return await dispatch("insert", fm1)
        },

        async insert({ commit, dispatch }, fm1) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: "Salvando", indeterminate: true },
                { root: true },
            )
            let payload = await this._vm.$axios
                .post("/OryxPlace/AnalysisFields/Insert", fm1)
                .then(response => {
                    commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
                    commit("setFm1", null)
                    return true
                })
                .catch(error => {
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                    return false
                })
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },

        async update({ commit, dispatch }, fm1) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: "Salvando", indeterminate: true },
                { root: true },
            )
            let payload = await this._vm.$axios
                .put("/OryxPlace/AnalysisFields/Update", fm1)
                .then(response => {
                    commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
                    return true
                })
                .catch(error => {
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                    return false
                })
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },

       async delete({ dispatch }, fm1id) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
                { root: true }
            )

            try {
                const response = await this._vm.$axios.delete(
                `/OryxPlace/AnalysisFields/Delete/${fm1id}`
                )

                Utils.ValidateAxiosResponse(response.data)

                return true   
            }
            catch (error) {
                dispatch(
                "parameters/openDialog",
                {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message,
                },
                { root: true }
                )

                return false  
            }
            finally {
                dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: false, text: "" },
                { root: true }
                )
            }
        },

        async search({ commit, dispatch, state, getters }, { limit = 20, page = 1 }) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: "Buscando sub classes", indeterminate: true },
                { root: true },
            )
            commit("setLoading", true)
            commit("initForm")

            let url = `/OryxPlace/AnalysisFields/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`

           
            let payload = await this._vm.$axios
                .get(url)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data)
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch(error => {
                    commit("setLstFm1", [])
                    commit("setSearch", "")
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                    return false
                })
            commit("setLoading", false)
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },      
    },
}
